exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "html{overflow:hidden}.bg,body{margin:0}.bg{width:100%;position:relative;z-index:1;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;overflow:hidden}.bg:after{content:\"\";width:100%;height:100%;left:0;top:0;background:inherit;-webkit-filter:blur(5px);filter:blur(5px);z-index:2;-webkit-transform:scale(1.02);-moz-transform:scale(1.02);-ms-transform:scale(1.02);-o-transform:scale(1.02);transform:scale(1.02)}.bg:after,.main{position:absolute}.main{z-index:3;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.adImage,.adVideo{width:100%;height:100%}.closeBtn{z-index:99;position:absolute;top:3.3%;right:5.5%;margin:auto;padding:.3rem 0;-webkit-border-radius:60px;-moz-border-radius:60px;border-radius:60px;background-color:rgba(0,0,0,.3);font-size:.64rem;color:#fff;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./~/postcss-loader/lib!./src/rv/splash/assets/scss/splash.scss
// module id = 32
// module chunks = 0